import React from 'react';

const HatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1697_4523)">
      <path
        d="M17.4861 6.78591V11.9286M3.89642 8.92871V11.9286C3.89642 12.6106 4.43333 13.2646 5.38904 13.7469C6.34475 14.2291 7.64097 14.5 8.99254 14.5C10.3441 14.5 11.6403 14.2291 12.5961 13.7469C13.5518 13.2646 14.0887 12.6106 14.0887 11.9286V8.92871M16.9935 7.57618C17.1455 7.50849 17.2745 7.39727 17.3646 7.2563C17.4546 7.11534 17.5017 6.95081 17.5 6.78311C17.4982 6.61542 17.4478 6.45191 17.3549 6.31285C17.262 6.17379 17.1307 6.06529 16.9773 6.00079L9.69751 2.65459C9.4762 2.55272 9.23579 2.5 8.99254 2.5C8.7493 2.5 8.50889 2.55272 8.28758 2.65459L1.00861 5.99736C0.857399 6.06419 0.728763 6.17404 0.638435 6.31348C0.548106 6.45292 0.5 6.61589 0.5 6.78248C0.5 6.94907 0.548106 7.11205 0.638435 7.25149C0.728763 7.39092 0.857399 7.50077 1.00861 7.56761L8.28758 10.9172C8.50889 11.0191 8.7493 11.0718 8.99254 11.0718C9.23579 11.0718 9.4762 11.0191 9.69751 10.9172L16.9935 7.57618Z"
        stroke="#007AAE"
        stroke-opacity="0.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1697_4523">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HatIcon;
